var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"65d8129bf60eb77d7910d40e4e58fa0a86ee05fc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["triptcip-web@triptcip"]={id:"65d8129bf60eb77d7910d40e4e58fa0a86ee05fc"};
      